import React from "react";
import {
    Grid,
    Box,
    Stack,
    Chip,
    Typography,
    useTheme,
    Paper,
    alpha,
} from "@mui/material";

import DateRangePicker from "../../../inputs/DateRangePicker/DateRangePicker";

import {
    // Event as EventIcon,
    CalendarMonth as CalendarIcon,
    Nightlight as NightIcon,
} from "@mui/icons-material";

const DateRangeSection = ({
    formData,
    errors,
    isArabic,
    handleDateChange,
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    return (
        <Grid container spacing={3}>
            {/* Date Picker */}
            <Grid item xs={12}>
                <DateRangePicker
                    startDate={
                        formData.start_date || ""
                    }
                    endDate={
                        formData.end_date || ""
                    }
                    onStartDateChange={(val) =>
                        handleDateChange(
                            "start_date",
                            val
                        )
                    }
                    onEndDateChange={(val) =>
                        handleDateChange(
                            "end_date",
                            val
                        )
                    }
                    error={
                        !!errors.start_date ||
                        !!errors.end_date
                    }
                    helperText={
                        errors.start_date ||
                        errors.end_date
                    }
                    required
                    isArabic={isArabic}
                    monthsToShow={2} // 🔥 أهم تعديل: شهرين بدون أسهم
                />
            </Grid>

            {/* Summary Card */}
            {formData.start_date &&
                formData.end_date && (
                    <Grid item xs={12}>
                        <Paper
                            variant="outlined"
                            sx={{
                                p: 2.5,
                                borderRadius: 3,
                                borderColor: alpha(theme.palette.primary.main, 0.2),
                                bgcolor: isDark ? alpha(theme.palette.primary.main, 0.05) : alpha(theme.palette.primary.main, 0.02),
                                display: 'flex',
                                alignItems: 'center',
                                gap: 3,
                                flexWrap: 'wrap'
                            }}
                        >
                            {/* Dates Flow */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: { xs: '1 1 100%', sm: 1 } }}>
                                <Box>
                                    <Typography variant="caption" color="text.secondary" fontWeight={600}>
                                        {isArabic ? "من" : "FROM"}
                                    </Typography>
                                    <Typography variant="h6" fontWeight={700} color="primary.main">
                                        {formData.start_date}
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary', px: 1 }}>
                                    <Typography variant="h5">→</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary" fontWeight={600}>
                                        {isArabic ? "إلى" : "TO"}
                                    </Typography>
                                    <Typography variant="h6" fontWeight={700} color="primary.main">
                                        {formData.end_date}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box sx={{ display: { xs: 'none', sm: 'block' }, width: '1px', height: 40, bgcolor: 'divider' }} />

                            {/* Duration */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flex: { xs: '1 1 100%', sm: 'none' } }}>
                                <Typography variant="caption" color="text.secondary" fontWeight={600}>
                                    {isArabic ? "مدة البرنامج" : "DURATION"}
                                </Typography>
                                <Stack direction="row" spacing={1}>
                                    <Chip
                                        size="small"
                                        icon={<CalendarIcon sx={{ fontSize: '1rem' }} />}
                                        label={`${formData.durations_days} ${isArabic ? "يوم" : formData.durations_days === 1 ? "Day" : "Days"}`}
                                        color="primary"
                                        sx={{ fontWeight: 600, px: 1 }}
                                    />
                                    {(formData.durations_nights || 0) > 0 && (
                                        <Chip
                                            size="small"
                                            icon={<NightIcon sx={{ fontSize: '1rem' }} />}
                                            label={`${formData.durations_nights} ${isArabic ? formData.durations_nights === 1 ? "ليلة" : "ليالي" : formData.durations_nights === 1 ? "Night" : "Nights"}`}
                                            color="secondary"
                                            sx={{ fontWeight: 600, px: 1 }}
                                        />
                                    )}
                                </Stack>
                            </Box>
                        </Paper>
                    </Grid>
                )}
        </Grid>
    );
};

export default DateRangeSection;